import { render, staticRenderFns } from "./ConfirmCreateCampaignTable.vue?vue&type=template&id=04fb61a5&scoped=true&%23default=dialog"
import script from "./ConfirmCreateCampaignTable.vue?vue&type=script&lang=ts"
export * from "./ConfirmCreateCampaignTable.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmCreateCampaignTable.vue?vue&type=style&index=0&id=04fb61a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2__lodash@4.18.1_pug@3.0.4_underscor_544b6cb00681b26f8947ee228cf90691/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb61a5",
  null
  
)

export default component.exports